<ng-template #drawerTpl>
    <div class="flex flex-col overflow-x-hidden overflow-y-auto">
        <vds-drawer-header class="sticky top-0 z-10 items-center gap-x-16 bg-white">
            <button vds-button appearance="ghost" (click)="closeDrawer()">
                <vds-icon name="arrow-previous" />
                <span>Close</span>
            </button>
        </vds-drawer-header>
        <div class="px-16 py-8">
            <span class="text-18 font-semibold">Feature flags</span>
        </div>
        <div class="flex flex-col p-16">
            @for (feature of filteredFeatureFlags(); track feature.key) {
                <div class="flex items-start border-b border-b-gray-50 py-8">
                    <div class="flex flex-col gap-y-8">
                        <span class="text-14 font-semibold text-gray-900">{{ feature.name }}</span>
                        @if (feature.description) {
                            <span class="text-14 text-gray-800">{{ feature.description }}</span>
                        }
                    </div>
                    <vds-switch
                        class="ml-auto inline-flex"
                        [inputId]="feature.key"
                        [checked]="feature.enabled"
                        (toggleChange)="toggleFlag($event, feature)"
                    >
                        <span class="sr-only">{{ feature.name }}</span>
                    </vds-switch>
                </div>
            }
        </div>
    </div>
</ng-template>
